
export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  // game1Url: process.env.VUE_APP_GAME1_BASE_URL,
  aa:process.env.VUE_APP_AA,
  baseUrl: process.env.VUE_APP_BASE_URL,
  userBaseUrl: "/member",
  userFundUrl: "/fund",
  userReportUrl: "/report",
  userReviewUrl: "/memberreview",
  cmsUrl: "/cms",
  gsPayUrl: "/gspay",
  couponUrl: "/couponcode",
  minigameUrl: "/minigame",
  missionUrl: "/mission",
  // paymentGatewayUrl: "/paymentgateway",
  paymentGatewayUrl: "/payg",
  result_url: process.env.VUE_APP_EPIC_RESULT,
  bankList: [],
  account_name: "EPICWIN",
  accessKey: "xu1iso9as",   //for top ten popular games, top multiplier win API
  wbetWidget: process.env.VUE_APP_WBET_WIDGET,
  wBetUrl: process.env.VUE_APP_WBET_URL,
  epicGame: process.env.VUE_APP_EPIC_URL,
  epic2: process.env.VUE_APP_EPIC2_URL,
  live22Game: process.env.VUE_APP_LIVE22_URL,
  spadeGaming: process.env.VUE_APP_SPADE_GAMING,
  habaneroGame: process.env.VUE_APP_HABANERO_URL,
  pragmaticGame: process.env.VUE_APP_PRAGMATIC_URL,
  epicResultUrl: process.env.VUE_APP_EPIC_RESULT,
  useConfigUrl: process.env.VUE_APP_STATIC_URL,
  jokerGame: process.env.VUE_APP_JOKER_URL,
  megaH5Game:process.env.VUE_APP_MEGAH5_URL,
  cq9Game: process.env.VUE_APP_CQ9_URL,
  jiliGame: process.env.VUE_APP_JILI_URL,
  oneApi:process.env.VUE_APP_ONEAPI_URL,
  imageUrl: process.env.VUE_APP_IMAGE_URL, 
  // getGame1Url() {
  //   return this.game1Url;
  // },
  min: 85,
  minE: 92,
  max: 98,
  precision: 2,

  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    
    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }
    
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },

  getBaseUrl() {
    return this.baseUrl;
    // if (this.useConfigUrl == "true") {
    //   return this.baseUrl;
    // }
    // var domain = this.getDomain(window.location.hostname, false);
    // if (domain != "localhost") {
    //   if(this.useConfigUrl == "true"){
    //     return this.baseUrl;
    //   }else{
    //     return "https://api." + domain;
    //   }     
    // } else { 
    //   return this.baseUrl;
    // }
  },

  membersignup() {
    return this.getBaseUrl() + this.userBaseUrl + "/membersignup";
  },
  memberLogin() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlogin";
  },
  getBalance() {
    return this.getBaseUrl() + this.userFundUrl + "/getbalance";
  },
  updatePassword() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberupdatepassword";
  },
  forgotPassword() {
    return this.getBaseUrl() + this.userBaseUrl + "/forgotpassword";
  },
  debounceSearch() {
    return this.getBaseUrl() + this.userBaseUrl + "/membercheckexist";
  },
  memberAddBank() {
    return this.getBaseUrl() + this.userFundUrl + "/addmemberbank";
  },
  getMemberBankList() {
    return this.getBaseUrl() + this.userFundUrl + "/getmemberbanklist";
  },
  bankLookUp() {
    return this.getBaseUrl() + this.userFundUrl + "/banklookup";
  },
  getBankingMode() {
    return this.getBaseUrl() + this.userFundUrl + "/bankingmode";
  },
  addDepositTicket() {
    return this.getBaseUrl() + this.userFundUrl + "/deposit";
  },
  addWithdrawTicket() {
    return this.getBaseUrl() + this.userFundUrl + "/withdrawal";
  },
  getMemberTicketList() {
    return this.getBaseUrl() + this.userReportUrl + "/getticketlist";
  },
  iBankTransfer() {
    return this.getBaseUrl() + this.paymentGatewayUrl + "/ibanktransfer";
  },
  launchGame() {
    return this.getBaseUrl() + this.userBaseUrl + "/launchgame";
  },
  getPromotionStatus() {
    return this.getBaseUrl() + this.userFundUrl + "/getpromotionstatus";
  },
  getMemberStatement() {
    return this.getBaseUrl() + this.userReportUrl + "/getstatement";
  },
  getMemberTransferDetails() {
    return this.getBaseUrl() + this.userReportUrl + "/gettransferlist";
  },
  getPlatformWinLose() {
    return this.getBaseUrl() + this.userReportUrl + "/getplatformwinlose";
  },
  getMemberVipDetails() {
    return this.getBaseUrl() + this.userBaseUrl + "/membervipdetails";
  },
  getContactUsList() {
    return this.getBaseUrl() + this.userBaseUrl + "/getsociallist";
  },
  getContactUsListBeforeLogin(){
    return this.getBaseUrl() + this.userBaseUrl + "/getcontactlistbeforelogin"
  },
  memberTacValidate(){
    return this.getBaseUrl() + this.userBaseUrl + "/membertacvalidate";
  },
  memberRenewTac(){
    return this.getBaseUrl() + this.userBaseUrl + "/membertacrenew";
  },
  getReferralCode(){
    return this.getBaseUrl() + this.userBaseUrl + "/getmemberreferralcode";
  },
  addReferralCode(){
    return this.getBaseUrl() + this.userBaseUrl + "/addmemberreferralcode";
  },
  getPromoStatement(){
    return this.getBaseUrl() + this.userReportUrl + "/getbonuslist";
  },
  getAdjustmentDetails(){
    return this.getBaseUrl() + this.userReportUrl + "/getadjustmentlist";
  },
  getRefereeList(){
    return this.getBaseUrl() + this.userReportUrl + "/getrefereelist";
  },
  getInboxList(){
    return this.getBaseUrl() + this.userFundUrl + "/getinboxlist";
  },
  inboxClaim(){
    return this.getBaseUrl() + this.userFundUrl + "/inboxclaim";
  },
  getTopTenDepositWithdraw(){
    return this.getBaseUrl() + this.userBaseUrl + "/gettoptendw";
  },
  memberBankTac() {
    return this.getBaseUrl() + this.userFundUrl + "/memberbanktac";
  },
  memberTransferMember(){
    return this.getBaseUrl() + this.userFundUrl + "/membertransfermember";
  },
  transferTac(){
    return this.getBaseUrl() + this.userFundUrl + "/transfertac";
  },
  getGraphData(){
    return this.getBaseUrl() + this.userBaseUrl + "/graph";
  },
  getSurveyQuestion(){
    return this.getBaseUrl() + this.userReviewUrl + "/getreviewlookup";
  },
  getTopTenReview(){
    return this.getBaseUrl() + this.userReviewUrl + "/gettoptensurveylist";
  },
  memberReview(){
    return this.getBaseUrl() + this.userReviewUrl + "/memberreview";
  },
  submitVideoUrl(){
    return this.getBaseUrl() + this.userBaseUrl + "/videoupsert";
  },
  gsPayTransfer(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositgspay";
  },
  gspaySol(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositgspaysolution";
  },
  gspayEwallet(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositgspaysolutionewallet";
  },
  uPay(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositupay";
  },
  // getCouponDetails(){
  //   return this.getBaseUrl() + this.couponUrl + "/getcoupondetails";
  // },
  gsPayCoupon(){
    return this.getBaseUrl() + this.couponUrl + "/coupondepositgspay"
  },
  iBankCoupon(){
    return this.getBaseUrl() + this.couponUrl + "/coupondepositibank"
  },
  addDepositTicketCoupon(){
    return this.getBaseUrl() + this.couponUrl + "/couponmanualdeposit"
  },
  getRefLink(){
    return this.getBaseUrl() + this.userBaseUrl + "/getreflink"
  },
  updateEmail(){
    return this.getBaseUrl() + this.userBaseUrl + "/updateemail"
  },
  peBankTransfer(){
    // return this.baseUrl + this.paymentGatewayUrl + "/pebanktransfer"
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositpepay"
  },
  pepin(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositpepaypaypin"
  },
  // peCoupon(){
  //   return this.getBaseUrl() + this.couponUrl + "/coupondepositpe"
  // },
  winpay(){
    // return this.baseUrl + this.paymentGatewayUrl + "/winpaytransfer"
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositwinpay"
  },
  // winpayCoupon(){
  //   return this.getBaseUrl() + this.couponUrl + "/coupondepositwinpay"
  // },
  mytelco(){
    // return this.baseUrl + this.paymentGatewayUrl + "/winpaytransfer"
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositmytelco"
  },
  sulifu(){
    return this.getBaseUrl() + this.paymentGatewayUrl + "/depositsulifu"
  },
  getXchangeRate(){
    return this.getBaseUrl() + this.userFundUrl + "/exchangeratelist";
  },

  /* referral */
  getReferCount(){
    return this.getBaseUrl() + this.userReportUrl + "/getmemberrefereecount"
  },
  getReferRebate(){
    return this.getBaseUrl() + this.userReportUrl + "/getmemberreferralrebate"
  },
  getReferCountDetail(){
    return this.getBaseUrl() + this.userReportUrl + "/getmemberrefereecountdetail"
  },
  getReferRebateDetail(){
    return this.getBaseUrl() + this.userReportUrl + "/getmemberreferralrebatedetail"
  },
  getRebateChart(){
    return this.getBaseUrl() + this.userReportUrl + "/rebatechart"
  },
  getRebate() {
    return this.getBaseUrl() + this.userFundUrl + "/memberrebateself";
  },
  getRebateDownline(){
    return this.getBaseUrl() + this.userFundUrl + "/memberrebatedownline";
  },
  getTurnoverDownline(){
    return this.getBaseUrl() + this.userReportUrl + "/getturnovermember";
  },
  getTurnoverProvider(){
    return this.getBaseUrl() + this.userReportUrl + "/getturnoverprovider";
  },
  claimRebate(){
    return this.getBaseUrl() + this.userFundUrl + "/rebateselfclaim";
  },
  claimRebateDownline(){
    return this.getBaseUrl() + this.userFundUrl + "/rebatedownlineclaim";
  },
  getReferralRebateList(){
    return this.getBaseUrl() + this.userReportUrl + "/getreferralrebatelist";
  },


  getProviderGameOfflist(){
    return this.getBaseUrl() + this.userBaseUrl + "/providergameofflist"
  },
  cnyDeposit(){
    return this.getBaseUrl() + this.missionUrl + "/cnydeposit"
  },
  missionDetails(){
    return this.getBaseUrl() + this.missionUrl + "/missiondetails"
  },
  missionClaim(){
    return this.getBaseUrl() + this.missionUrl + "/missionclaim"
  },
  rayaDeposit(){
    return this.getBaseUrl() + this.missionUrl + "/depositraya"
  },
  tierDeposit(){
    return this.getBaseUrl() + this.missionUrl + "/cnydepositv2"
  },
  campaignRewardclick(){
    return this.getBaseUrl() + this.missionUrl + "/campaignrewardclick";
  },
  getSpinToken(){
    return this.getBaseUrl() + this.minigameUrl + "/minigamebalance"
  },
  getSmashToken(){
    return this.getBaseUrl() + this.minigameUrl + "/minigamebalance"
  },
  spinEgg(){
    return this.getBaseUrl() + this.minigameUrl + "/minigamedebit"
  },
  smashEgg(){
    return this.getBaseUrl() + this.minigameUrl + "/minigamedebit"
  },
  eurocup(){
    return this.getBaseUrl() + this.minigameUrl + "/eurocup"
  },
  eurocupCheck(){
    return this.getBaseUrl() + this.minigameUrl + "/eurocupcheck"
  },

  getNumbers(){
    return this.getBaseUrl() + this.minigameUrl + "/luckynumberget"
  },
  getWinners(){
    return this.getBaseUrl() + this.minigameUrl + "/luckynumberwinner"
  },

  /* cms */
  getAnnBanner(){
    return this.getBaseUrl() + this.cmsUrl + "/announcementbannerlist"
  },
  getSlideBanner(){
    return this.getBaseUrl() + this.cmsUrl + "/slidebannerlist"
  },
  getPromoBanner(){
    return this.getBaseUrl() + this.cmsUrl + "/promotionbanner"
  },
  getSeo(){
    return this.getBaseUrl() + this.cmsUrl + "/seopagedetails"
  },
  getNewsList(){
    return this.getBaseUrl() + this.cmsUrl + "/newslist"
  },
  getNewsDetails(){
    return this.getBaseUrl() + this.cmsUrl + "/newsdetails"
  },

  /* slots */
  // games
  launchEpic(){
    return this.epicGame + "/epiclaunchgame"
  },
  getEpicGamelist(){
    return this.epicGame + "/getGameList"
  },
  launchEpic2(){
    return this.epic2 + "/launchgame"
  },
  getEpic2list(){
    return this.epic2 + "/getgamelist?lang="
  },
  launchLive22(){
    return this.live22Game + "/launchgame"
  },
  getLive22GameList(){
    return this.live22Game + "/getgamelist?lang=en"
  },
  launchHabanero(){
    return this.habaneroGame + "/launchgame"
  },
  getHBGameList(){
    return this.habaneroGame + "/getgamelist"
  },
  launchSpadeGaming(){
    return this.spadeGaming + "/launchgame"
  },
  getSGGamelist(){
    return this.spadeGaming + "/getgamelist"
  },
  getPragmaticList(){
    return this.pragmaticGame + "/getgamelist"
  },
  launchPragmatic(){
    return this.pragmaticGame + "/launchgame"
  },
  getJokerList(){
    return this.jokerGame + "/getgamelist"
  },
  launchJoker(){
    return this.jokerGame + "/launchgame"
  },
  launchMegaH5(){
    return this.megaH5Game + "/launchgame"
  },
  getMegaH5GameList(){
    return this.megaH5Game + "/getgamelist?lang=en"
  },
  launchCq9(){
    return this.cq9Game + "/launchgame"
  },
  getJiliList(){
    return this.jiliGame + "/getgamelist"
  },
  launchJili(){
    return this.jiliGame + "/launchgame"
  },
  getOneapiList(){
    return this.oneApi + "/getgamelist"
  },
  launchOneapi(){
    return this.oneApi + "/launchgame"
  },

  /* sportbook */
  launchWbet(){
    return this.wBetUrl + "/launchgame"
  },


  /* statement */
  getGameResultSlot(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultslot";
  },
  getGameResultLivecasino(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultlc";
  },
  getGameResultRebate(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultrebate"
  },
  getGameResultSb(){
    return this.getBaseUrl() + this.userReportUrl + "/getgameresultsp"
  },


  /* game result */
  getSpadeResult(){
    return this.spadeGaming + "/getbetdetail"
  },
  getHbResult(){
    return this.habaneroGame + "/getbetdetail"
  },
  getEpic2Result(){
    return this.epic2 + "/getbetdetail"
  },
  getLive22Result(){
    return this.live22Game + "/getbetdetail"
  },
  getPpsResult(){
    return this.pragmaticGame + "/getbetdetail"
  },
  getJokerResult(){
    return this.jokerGame + "/getbetdetail"
  },
  getMegaH5Result(){
    return this.megaH5Game + "/getbetdetail"
  },
  getCq9Result(){
    return this.cq9Game + "/getbetdetail"
  },
  getJiliResult(){
    return this.jiliGame + "/getbetdetail"
  },
  getOneapiResult(){
    return this.oneApi + "/getbetdetail"
  },


  //minigame
  getMiniGameBalance(){
    return this.getBaseUrl() + this.minigameUrl + "/minigamebalance"
  },
  spinWheel(){
    return this.getBaseUrl() + this.minigameUrl + "/minigamedebit"
  },
};
